import React, { CSSProperties } from 'react';
import { RoutineExercise } from 'hevy-shared';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { H3, P3 } from 'styleguide/Texts';
import styled from 'styled-components';
import { Card } from 'styleguide/Card';
import { exercisesToSupersetGroups } from 'components/ExerciseSummary/utils';
import { SupersetGroupCell } from 'components/ExerciseSummary/SupersetGroupCell';

const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: ${Spacing.md}px;
`;

interface RoutineCellProps {
  exercises: RoutineExercise[];
  notes: string | null;
  title: string;
  style?: CSSProperties;
}

export const RoutineCell = ({ exercises, style, title, notes }: RoutineCellProps) => {
  const supersetGroups = exercisesToSupersetGroups({ exercises });
  return (
    <Container style={style}>
      <View style={{ paddingInlineStart: Spacing.sm, paddingBottom: Spacing.md }}>
        <H3>{title}</H3>
        {notes && <P3>{notes}</P3>}
      </View>
      {supersetGroups.map((supersetGroup, index) => (
        <SupersetGroupCell
          key={`${supersetGroup.supersetId || supersetGroup.exercises[0]?.title}`}
          supersetId={supersetGroup.supersetId}
          exercises={supersetGroup.exercises}
          showDivider={index !== supersetGroups.length - 1}
        />
      ))}
    </Container>
  );
};
